import { render, staticRenderFns } from "./DataFormInput.vue?vue&type=template&id=4af1e408&"
import script from "./DataFormInput.vue?vue&type=script&lang=ts&"
export * from "./DataFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports